import { Component, OnInit } from '@angular/core';
import { Endpoints } from '@huge-monorepo/portal/config';
import { GenericService, UserRightsService } from '@huge-monorepo/portal/services';

@Component({
  selector: 'huge-monorepo-cdr-map',
  templateUrl: './cdr-map.component.html',
  styleUrl: './cdr-map.component.scss',
})
export class CdrMapComponent{
  constructor(private genericService: GenericService, private endpoints: Endpoints, private auth: UserRightsService){}

  simLocationEndpoint = this.endpoints.GET_SIMS_GENERAL;
  gs = this.genericService;
  portalGroupID = this.auth.GetGroupID();
}
